import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent { }



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/containers/full-layout/full-layout.component.ts